import JoinMember from "javascripts/webpage/join-member";

document.addEventListener("DOMContentLoaded", () => {
  if (!document.getElementById("js-hotels-plans")) {
    return;
  }
  JoinMember();
});
